(function () {
  document.querySelectorAll('[data-be-store]').forEach(function (root) {
    var slides = root.querySelectorAll('.be-store__slide');
    var hi = 0;

    function heroGo(d) {
      if (!slides.length) return;
      slides[hi].classList.remove('is-active');
      hi = (hi + d + slides.length) % slides.length;
      slides[hi].classList.add('is-active');
    }

    root.querySelectorAll('[data-be-hero]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        heroGo(Number(btn.getAttribute('data-be-hero')));
      });
    });

    if (slides.length > 1) {
      setInterval(function () {
        heroGo(1);
      }, 7000);
    }

    root.querySelectorAll('[data-be-scroll]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.be-store__wrap');
        if (!wrap) return;
        var el = wrap.querySelector('.be-store__slider');
        if (el) {
          el.scrollBy({
            left: Number(btn.getAttribute('data-dir')) * 480,
            behavior: 'smooth'
          });
        }
      });
    });
  });
})();
